import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=65a8c668&scoped=true&"
import script from "./ContractsList.vue?vue&type=script&lang=js&"
export * from "./ContractsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=65a8c668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8c668",
  null
  
)

export default component.exports